import { Field } from "formik";

export const FormRadio = ({
  children,
  name,
  value,
  invalid,
  onClick,
}: {
  children: React.ReactNode;
  name: string;
  value: string;
  invalid?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}) => {
  return (
    <>
      <div className="form-check form-check--btn">
        <Field
          type="radio"
          className={`form-check-input ${invalid ? " is-invalid" : null}`}
          name={name}
          value={value}
          id={`${name}-${value}`}
          onClick={onClick}
        />
        <label className="form-check-label" htmlFor={`${name}-${value}`}>
          {children}
        </label>
      </div>
    </>
  );
};

export const FormRadioList = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  const { children, className } = props;
  return (
    <div
      className={`form-validated-list d-inline-flex flex-column gap-1 position-relative${
        className ? ` ${className}` : ""
      }`}
    >
      {children}
    </div>
  );
};
